import React from 'react';

import { Text } from '@adc/parallax-component-library';
import { IconProps } from '@adc/parallax-icons';
import styled from 'styled-components';

type LinkProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  onPress?: () => void;
  disabled?: boolean;
  testID: string;
  IconElement?: React.NamedExoticComponent<IconProps>;
  textColor?: any;
  fontSize?: any;
  fontWeight?: any;
  padding?: any;
};

const BtnWrapper = styled.button`
  border: none;
  background: none;
  padding: 0;
  margin: auto;
  display: flex;
  justify-content: 'center';
  cursor: pointer;
`;

const Link = ({
  children,
  onPress,
  disabled,
  testID,
  IconElement,
  textColor = '$interactive.tertiary.enabled.text',
  fontSize = '$bodyBase.strong',
  fontWeight = '$bodyBase.strong',
  padding = '$0',
  ...rest
}: LinkProps) => {
  return (
    <BtnWrapper id={testID} onClick={onPress} disabled={disabled} {...rest}>
      {IconElement && (
        <IconElement color="$interactive.tertiary.enabled.text" testID={`${testID}-icon`} />
      )}
      <Text
        marginLeft={IconElement ? '$2' : '$0'}
        padding={padding}
        fontSize={fontSize}
        fontWeight={fontWeight}
        color={disabled ? '$interactive.tertiary.disabled.text' : textColor}
        testID={`${testID}-text`}
      >
        {children}
      </Text>
    </BtnWrapper>
  );
};

export { Link };
